import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FullNavigationComponent } from './components/full-navigation/full-navigation.component';

const routes: Routes = [
  {
    path: '',
    component: FullNavigationComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
